<template>
   <nav class="bg-transparent border-gray-200 px-2 sm:px-4 py-2.5 rounded">
      <div
         class="container flex flex-wrap items-center justify-between mx-auto">
         <router-link to="/" class="flex items-center">
            <span
               class="self-center text-xl font-semibold whitespace-nowrap dark:text-white"
               >E-Qur'an</span
            >
         </router-link>

         <div class="sm:hidden block">
            <button
               @click="toggle"
               data-collapse-toggle="navbar-default"
               type="button"
               class="inline-flex items-center p-2 ml-3 text-sm text-white rounded-lg md:hidden hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-slate-100">
               <span class="sr-only">Open main menu</span>
               <svg
                  class="w-6 h-6"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                     fill-rule="evenodd"
                     d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                     clip-rule="evenodd"></path>
               </svg>
            </button>
         </div>

         <div
            :class="
               open
                  ? ' block w-full md:block md:w-auto'
                  : 'hidden  w-full md:block md:w-auto'
            "
            id="navbar-default">
            <ul
               class="flex flex-col p-4 mt-4 border border-gray-100 rounded-lg bg-transparent md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0">
               <li>
                  <router-link
                     to="/"
                     class="block py-2 pl-3 pr-4 text-white active:bg-darkblue active:text-white hover:bg-darkblue hover:rounded-full md:border-0"
                     aria-current="page"
                     exact
                     >Home</router-link
                  >
               </li>
               <li>
                  <router-link
                     to="/audio"
                     class="block py-2 pl-3 pr-4 text-white rounded hover:bg-darkblue hover:rounded-full md:border-0"
                     >Murottal</router-link
                  >
               </li>
               <li>
                  <router-link
                     to="/doa"
                     class="block py-2 pl-3 pr-4 text-white rounded hover:bg-darkblue hover:rounded-full md:border-0"
                     >Doa</router-link
                  >
               </li>
            </ul>
         </div>
      </div>
   </nav>
</template>

<script>
export default {
   name: "NavbarComponent",
   data() {
      return {
         open: false,
      };
   },
   methods: {
      toggle() {
         this.open = !this.open;
      },
   },
};
</script>

<style></style>
